import React, { Component } from 'react';
import { Segment, Header, List } from 'semantic-ui-react';

export default class Acknowledgements extends Component {
  render() {
    return (
      <Segment vertical>
        <Header as='h1' content="Acknowledgements" />
        <p>
          Much of the design and many of the materials of this course were either inspired by, borrowed from,
          or adapted from a variety of courses from my friends and mentors here at Georgia Tech and at other
          universities, including:
        </p>

        <List bulleted>
          <List.Item as="a" href="https://faculty.washington.edu/ajko/info360/" target="_blank">Amy Ko's INFO 360 at University of Washington</List.Item>
          <List.Item as="a" href="https://hcicourses.stanford.edu/cs376/2018/index.php" target="_blank">Michael Bernstein's CS 376 at Stanford</List.Item>
          <List.Item as="a" href="https://super.cs.uchicago.edu/usable18/" target="_blank">Blase Ur's CMSC 2/33210 at University of Chicago</List.Item>
          <List.Item as="a" href="https://canvas.cmu.edu/courses/3216" target="_blank">Lorrie Cranor’s 05-4/836 at CMU</List.Item>
          <List.Item as="a" href="https://www.cc.gatech.edu/fac/Amy.Bruckman/teaching/4001/fall2018/" target="_blank">Amy Bruckman's CS4001 at Georgia Tech</List.Item>
        </List>
      </Segment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/acknowledgments.js